import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "b3a93469-a8da-41a9-a78b-70ac93fcc9c8",
    content: "A noise map describes the sound level on a map, based on the sound sources in the scene.",
    options: {},
  },
  {
    id: "ce2efa06-ccf7-4023-904c-f44f839a7e3e",
    content:
      "More generally, a sound map can also describe various parameters on a map related to acoustics, such as speech intelligibility, sound pressure level, other psychoacoustic properties.",
    options: {},
  },
  {
    id: "ac946dcd-995d-4d95-b634-b1f24f45349b",
    content:
      "Noise maps are helpful to analyse the sound pressure level distribution in an outdoor environment and to figure out noise control problems.",
    options: {},
  },
  {
    id: "ddf86208-bad9-46f1-83bc-0853e5a647d3",
    content: "It is always possible to improve the soundscape of a given scenario by reducing the level.",
    options: {},
  },
  {
    id: "3d197b9b-f763-48a2-9e51-ea7ca60ce5e2",
    content: "Auralisation is essential to get an acoustic impression of the scene.",
    options: {},
  },
];

export const task: Task = {
  id: "cfda56e9-0509-490f-9e59-3bc38b30d717",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "b3a93469-a8da-41a9-a78b-70ac93fcc9c8",
    "ce2efa06-ccf7-4023-904c-f44f839a7e3e",
    "ac946dcd-995d-4d95-b634-b1f24f45349b",
    "3d197b9b-f763-48a2-9e51-ea7ca60ce5e2",
  ],
};
